import { useContext, useState, useRef, useEffect, createContext } from 'react';

type DrawerCtx = {
  currentIdx: number;
  onOpen: () => void;
  onClose: () => void;
  offset: number;
};

export const DrawerContext = createContext<DrawerCtx>({
  currentIdx: 0,
  onOpen: () => {},
  onClose: () => {},
  offset: 0,
});

export function useDrawerStacking({ isOpen }: { isOpen: boolean }) {
  const { currentIdx, onOpen, onClose } = useContext(DrawerContext);
  const [offset, setOffset] = useState(0);
  const prevIsOpen = useRef(isOpen);

  useEffect(() => {
    if (prevIsOpen.current === isOpen) return;

    prevIsOpen.current = isOpen;
    handleToggleOpen(isOpen);
  }, [prevIsOpen, isOpen]);

  function handleToggleOpen(open: boolean) {
    if (open) {
      onOpen();
    } else {
      onClose();
    }
  }

  function handleOnOpenChange(open: boolean) {
    prevIsOpen.current = open;
    handleToggleOpen(open);
  }

  return {
    providerContext: {
      currentIdx: currentIdx + 1,
      offset,
      onOpen: () => {
        setOffset((prev) => prev + 1);
        onOpen();
      },
      onClose: () => {
        setOffset(Math.max(offset - 1, 0));
        onClose();
      },
    },
    handleOnOpenChange,
    offset,
    isFirst: currentIdx < 1,
  };
}
